// extracted by mini-css-extract-plugin
module.exports = {"BasicAssetTable":"styles_BasicAssetTable__q6lJa"};